import React from "react";
import { useCmsSlider } from "../../context/CmsSliderContext";
import newsAndPrData from "../../data/newsAndPr.json";

export default function Section2() {
  const { setIsOpenSlider } = useCmsSlider();

  return (
    <div className="Section2 bg-[#F5F5F5] pb-[30px]">
      <div className="container-1280 section2-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h1 className="text-[#da2128] font-bold text-center text-[34px] leading-[40px] pt-8">
          PR & News
        </h1>

        <p className="text-[16px] leading-normal text-black text-center font-bold mt-4 capitalize">
          We’re proud to be consistently recognized as the fastest-growing
          technology company in Pakistan, earning a variety of awards and
          recognition in several key areas.
        </p>

        <div className="pt-8">
          {newsAndPrData.map(
            ({ imagesUrl, title, text, readMoreLink }, index) => {
              return (
                <div
                  key={index}
                  className={`flex w-full pb-[40px] flex-col ${
                    index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  <div className={`md:w-[50%] ${index % 2 === 0 ? "md:pr-[15px]" : "md:pl-[15px]"}`}>
                    <img className="block w-full" src={imagesUrl[0]} onClick={() => setIsOpenSlider({ show: true, index:0, slides: imagesUrl })}></img>
                  </div>

                  <div className={`md:w-[50%] ${index % 2 === 0 ? "md:pl-[15px]" : "md:pr-[15px]"}`}>
                    <div className="text-center lg:pt-[140px]">
                      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-bold">
                        {title}
                      </h2>

                      <p className="text-[14px] mb-5 leading-[1.5]">{text}</p>

                      {readMoreLink && (
                        <p className="mb-5 font-bold">
                          <a
                            href={readMoreLink} // Replace with a valid URL or dynamic variable
                            className="leading-[1.5] hover:text-[#cd2122]"
                          >
                            Read More
                          </a>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
}
